import { SelectableVariantRadio, SelectableVariantTile } from './fuel-type';

const Templates = {
  SelectableVariantRadio,
  SelectableVariantTile
};

export const getTemplate = (templateName) => Templates?.[templateName] || null;